import { Injectable } from '@angular/core';
import { CreditCardsTableItem } from './credit-cards-data-source.token';

/**
 * Stores the currently selected credit card item to preserve context
 * when navigating from the credit cards list to the credit card summary page.
 */
@Injectable({ providedIn: 'root' })
export class CreditCardIdentityService {
  private currentCard: CreditCardsTableItem | undefined;

  /**
   * Returns the currently selected credit card item, or `undefined` if none has been set.
   */
  public get(): CreditCardsTableItem | undefined {
    return this.currentCard;
  }

  /**
   * Sets the currently selected credit card item to be used on the summary page.
   */
  public set(card: CreditCardsTableItem): void {
    this.currentCard = card;
  }
}
